<template>
  <div style="height: 100%;">
    <!-- <div class="header">
      <h1>{{ chartTitle }}</h1>
      <p>{{ chartSubtitle }}</p>
    </div> -->
    <div class="data-info">
      <div class="data-summary">
        <div class="summary-header">
          <h3>区域统计</h3>
          <div class="time-switch inline">
            <button 
              class="switch-btn" 
              :class="{ active: timeType === 'month' }"
              @click="switchTimeType('month')">
              按月
            </button>
            <button 
              class="switch-btn" 
              :class="{ active: timeType === 'day' }"
              @click="switchTimeType('day')">
              按日
            </button>
          </div>
          <div class="region-filter">
            <el-select
              v-model="selectedCommunity"
              placeholder="选择社区"
              size="mini"
              clearable
              @change="handleCommunityChange"
            >
              <el-option
                v-for="item in communities"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-select
              v-model="selectedBuilding"
              placeholder="选择楼栋"
              size="mini"
              clearable
              @change="handleDateChange"
            >
              <el-option
                v-for="item in buildings"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="date-filter">
            <el-date-picker
              v-if="timeType === 'month'"
              v-model="selectedYear"
              type="year"
              format="yyyy 年"
              value-format="yyyy"
              placeholder="选择年份"
              size="mini"
              @change="handleDateChange"
            />
            <el-date-picker
              v-else
              v-model="selectedMonth"
              type="month"
              format="yyyy 年 MM 月"
              value-format="yyyy-MM"
              placeholder="选择月份"
              size="mini"
              @change="handleDateChange"
            />
          </div>
        </div>
        <p>{{ totalWaterLabel }}: <span class="highlight">{{ newUserTotal }} 方</span></p>
      </div>
    </div>
    <div class="chart-container">
      <div class="chart-wrapper">
        <div ref="chart" style="width: 100%; height: 100%;"></div>
      </div>
    </div>  
  </div>
</template>

<script>
// 注意：在Vue项目中需要先安装echarts: npm install echarts
import * as echarts from 'echarts'
import { rightBoot2 } from '@/api/ksharge'

export default {
  name: 'RechargeChart',
  data() {
    return {
      myChart: null,
      xData: [],
      showDataZoom: true,
      timeType: 'month', // 'month' 或 'day'
      dataTypes: [],
      monthlyDates: [], // 保存月份日期信息
      dailyDates: [], // 保存日期信息
      selectedYear: '',
      selectedMonth: '',
      selectedCommunity: null, // 选中的社区ID
      selectedBuilding: null, // 选中的楼栋ID
      communities: [], // 社区列表
      buildings: [], // 楼栋列表
      colors: [
        '#19ffe0', '#4169E1', '#ff9d19', '#bf19ff',
        '#5f45ff', '#02cdff', '#f9e264', '#f47a75',
        '#009db2', '#314976'
      ],
      monthData: {},
      dayData: {},
      selected_year_total_usage: 0, // 本年度总用水量
      selected_month_total_usage: 0 // 本月总用水量
    }
  },
  computed: {
    totalWaterLabel() {
      if (this.timeType === 'month') {
        // 按月：显示年份 + 年度总用水量
        const year = this.selectedYear || new Date().getFullYear()
        return `${year}年度总用水量`
      } else {
        // 按日：显示年月 + 月总用水量
        let yearMonth = this.selectedMonth
        if (!yearMonth) {
          const now = new Date()
          yearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
        }
        // 将 "2024-11" 格式转换为 "2024年11月"
        const [year, month] = yearMonth.split('-')
        return `${year}年${parseInt(month)}月总用水量`
      }
    },
    newUserTotal() {
      // 根据按钮状态使用不同的参数
      if (this.timeType === 'month') {
        // 点击"按月"时，使用 selected_year_total_usage
        return (this.selected_year_total_usage || 0).toFixed(2)
      } else {
        // 点击"按日"时，使用 selected_month_total_usage
        return (this.selected_month_total_usage || 0).toFixed(2)
      }
    },
    currentSeries() {
      const data = this.timeType === 'month' ? this.monthData : this.dayData
      const barWidth = this.dataTypes.length > 1 ? 20 : 30
      return this.dataTypes.map((type, index) => ({
        name: type,
        type: 'bar',
        barMaxWidth: barWidth,
        barGap: this.dataTypes.length > 1 ? '20%' : '30%',
        barCategoryGap: '20%',
        itemStyle: {
          normal: {
            color: this.colors[index % this.colors.length],
            barBorderRadius: [4, 4, 0, 0],
            label: {
              show: true,
              position: "top",
              formatter: function(p) {
                return p.value > 0 ? p.value.toFixed(2) : ''
              },
              textStyle: {
                fontSize: 10,
                color: '#fff'
              }
            }
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 191, 183, 0.5)'
            }
          }
        },
        data: data[type] || []
      }))
    },
    chartOption() {
      return {
        backgroundColor: "transparent",
        title: {
          text: this.chartTitle,
          subtext: this.chartSubtitle,
          x: "4%",
          textStyle: {
            color: '#fff',
            fontSize: 22
          },
          subtextStyle: {
            color: '#90979c',
            fontSize: 16,
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            textStyle: {
              color: "#fff"
            }
          }
        },
        grid: {
          borderWidth: 0,
          top: 80,
          left: '18%',
          bottom: this.showDataZoom ? 65 : 40,
          textStyle: {
            color: "#fff"
          }
        },
        legend: {
          x: '4%',
          top: '8%',
          textStyle: {
            color: '#90979c',
            fontSize: 12
          },
          itemWidth: 12,
          itemHeight: 8,
          data: this.dataTypes
        },
        calculable: true,
        xAxis: [{
          type: "category",
          axisLine: {
            lineStyle: {
              color: '#90979c'
            }
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitArea: {
            show: false
          },
          axisLabel: {
            interval: 0,
            rotate: this.timeType === 'day' ? 45 : 0,
            fontSize: 11
          },
          data: this.xData,
        }],
        yAxis: [{
          type: "value",
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#90979c'
            }
          },
          axisLabel: {
            formatter: '{value} 方'
          },
          axisTick: {
            show: false
          },
          splitArea: {
            show: false
          }
        }],
        dataZoom: this.showDataZoom ? [{
          show: true,
          height: 16,
          xAxisIndex: [0],
          bottom: 18,
          start: 10,
          end: 80,
          handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
          handleSize: '80%',
          handleStyle: {
            color: "#d3dee5",
          },
          textStyle: {
            color: "#fff"
          },
          borderColor: "#90979c"
        }, {
          type: "inside",
          show: true,
          height: 8,
          start: 1,
          end: 35
        }] : [],
        series: this.currentSeries
      }
    }
  },
  mounted() {
    // 初始化年份、月份
    const now = new Date()
    this.selectedYear = now.getFullYear().toString()
    const month = now.getMonth() + 1
    this.selectedMonth = `${this.selectedYear}-${month.toString().padStart(2, '0')}`
    this.generateXData()
    this.initChart()
    window.addEventListener('resize', this.handleResize)
    // 获取社区列表
    this.fetchCommunities()
    // 调用接口获取数据
    this.fetchData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.myChart) {
      this.myChart.dispose()
    }
  },
  methods: {
    // 获取接口数据
    async fetchData() {
      try {
        const token = this.$store.state.print?.goodsForeNo?.token || sessionStorage.getItem('token')
        if (!token) {
          console.warn('缺少 token，无法获取数据')
          return
        }
        
        // 根据 timeType 组装参数（按月：传 year；按日：传 month，对应月份与年份，不受年份选择影响）
        let params = {
          token: token,
          time_range: this.timeType === 'month' ? 'year' : 'month'
        }

        if (this.timeType === 'month') {
          // 按月视图：仅传选中的年份
          params.year = parseInt(this.selectedYear || new Date().getFullYear())
          // month 可以不传，或传当前月占位（根据接口需要，这里不传）
        } else {
          // 按日视图：从选中的月份解析 year 与 month
          const monthStr = this.selectedMonth || ''
          const parts = monthStr.split('-')
          const parsedYear = parts[0] ? parseInt(parts[0]) : new Date().getFullYear()
          const parsedMonth = parts[1] ? parseInt(parts[1]) : (new Date().getMonth() + 1)
          params.year = parsedYear
          params.month = parsedMonth
        }
        
        // 添加区域查询参数
        if (this.selectedCommunity) {
          params.community_id = this.selectedCommunity
        }
        if (this.selectedBuilding) {
          params.building_id = this.selectedBuilding
        }
        
        console.log('请求参数:', params)
        const res = await rightBoot2(params)
        console.log('接口响应:', res)
        
        // 处理响应数据
        if (res && res.data) {
          let responseData = null
          if (res.data.status === 'success' && res.data.data) {
            responseData = res.data.data
          } else if (res.data.data) {
            responseData = res.data.data
          } else {
            responseData = res.data
          }
          
          console.log('处理后的数据:', responseData)
          
          if (responseData) {
            // 处理数据
            this.processResponseData(responseData, params.time_range)
            
            // 更新图表
            this.$nextTick(() => {
              if (this.myChart) {
                this.myChart.setOption(this.chartOption)
              }
            })
          }
        }
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    // 处理接口返回的数据
    processResponseData(data, time_range) {
      // 获取总用水量（如果接口返回了这些字段）
      if (data.selected_year_total_usage !== undefined) {
        this.selected_year_total_usage = parseFloat(data.selected_year_total_usage) || 0
      }
      if (data.selected_month_total_usage !== undefined) {
        this.selected_month_total_usage = parseFloat(data.selected_month_total_usage) || 0
      }
      
      // 处理按月或按日数据
      if (time_range === 'year') {
        // 按月数据 - 使用 monthly_usage
        this.processMonthlyData(data.monthly_usage || [])
      } else {
        // 按日数据 - 使用 daily_usage
        this.processDailyData(data.daily_usage || [])
      }
      
      // 重新生成X轴数据
      this.generateXData()
    },
    handleDateChange() {
      this.fetchData()
    },
    // 获取社区列表
    fetchCommunities() {
      const token = this.$store.state.print?.goodsForeNo?.token || sessionStorage.getItem('token')
      if (!token) {
        console.warn('缺少 token，无法获取社区列表')
        return
      }
      
      this.$api.userProfile.communities({ token }).then((res) => {
        if (res && res.data && res.data.status === 'success') {
          this.communities = res.data.data || []
        } else if (res && res.data && res.data.data) {
          this.communities = res.data.data || []
        }
        console.log('获取社区列表:', this.communities)
      }).catch(error => {
        console.error('获取社区列表失败:', error)
      })
    },
    // 获取楼栋列表
    fetchBuildings() {
      if (!this.selectedCommunity) {
        this.buildings = []
        this.selectedBuilding = null
        return
      }
      
      const token = this.$store.state.print?.goodsForeNo?.token || sessionStorage.getItem('token')
      if (!token) {
        console.warn('缺少 token，无法获取楼栋列表')
        return
      }
      
      this.$api.userProfile.buildings({
        token: token,
        community_id: this.selectedCommunity
      }).then((res) => {
        if (res && res.data && res.data.status === 'success') {
          this.buildings = res.data.data || []
        } else if (res && res.data && res.data.data) {
          this.buildings = res.data.data || []
        }
        console.log('获取楼栋列表:', this.buildings)
      }).catch(error => {
        console.error('获取楼栋列表失败:', error)
      })
    },
    // 社区选择变化
    handleCommunityChange() {
      // 清空楼栋选择
      this.selectedBuilding = null
      // 获取楼栋列表
      this.fetchBuildings()
      // 重新获取数据
      this.fetchData()
    },
    // 处理按月数据
    processMonthlyData(monthlyUsage) {
      console.log('处理按月数据:', monthlyUsage)
      // 单系列：用量
      this.dataTypes = ['用水量']
      this.monthlyDates = []
      const values = []

      if (Array.isArray(monthlyUsage) && monthlyUsage.length > 0) {
        // 按月份排序
        const sorted = [...monthlyUsage].sort((a, b) => {
          const monthA = a.month || ''
          const monthB = b.month || ''
          return monthA.localeCompare(monthB)
        })
        
        sorted.forEach(item => {
          if (item.month) {
            // 从月份中提取月份号（例如：2025-01 -> 1月）
            const monthMatch = item.month.match(/\d{4}-(\d{2})/)
            if (monthMatch) {
              const month = parseInt(monthMatch[1])
              const label = month + '月'
              this.monthlyDates.push(label)
              const usageValue = parseFloat(item.usage) || 0
              values.push(usageValue)
              console.log(`月份: ${label}, 用水量: ${usageValue}`)
            }
          }
        })
      }

      // 如果数据为空，生成12个月的默认数据
      if (this.monthlyDates.length === 0) {
        for (let i = 1; i <= 12; i++) {
          this.monthlyDates.push(i + '月')
          values.push(0)
        }
      }

      this.monthData = { '用水量': values }
      console.log('处理后的月份数据:', {
        monthlyDates: this.monthlyDates,
        monthData: this.monthData,
        values: values
      })
    },
    // 处理按日数据
    processDailyData(dailyUsage) {
      console.log('处理按日数据:', dailyUsage)
      // 单系列：用量
      this.dataTypes = ['用水量']
      this.dailyDates = []
      const values = []

      if (Array.isArray(dailyUsage) && dailyUsage.length > 0) {
        // 按日期排序
        const sorted = [...dailyUsage].sort((a, b) => {
          const dateA = a.date || ''
          const dateB = b.date || ''
          return dateA.localeCompare(dateB)
        })
        
        sorted.forEach(item => {
          if (item.date) {
            // 从日期中提取日期号（例如：2025-11-01 -> 1日）
            const dateMatch = item.date.match(/\d{4}-\d{2}-(\d{2})/)
            if (dateMatch) {
              const day = parseInt(dateMatch[1])
              const label = day + '日'
              this.dailyDates.push(label)
              const usageValue = parseFloat(item.usage) || 0
              values.push(usageValue)
              console.log(`日期: ${label}, 用水量: ${usageValue}`)
            }
          }
        })
      }

      // 如果数据为空，生成默认数据
      if (this.dailyDates.length === 0) {
        const now = new Date()
        const daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate()
        for (let i = 1; i <= daysInMonth; i++) {
          this.dailyDates.push(i + '日')
          values.push(0)
        }
      }

      this.dayData = { '用水量': values }
      console.log('处理后的日期数据:', {
        dailyDates: this.dailyDates,
        dayData: this.dayData,
        values: values
      })
    },
    generateXData() {
      if (this.timeType === 'month') {
        // 使用保存的月份日期信息
        this.xData = this.monthlyDates.length > 0 ? this.monthlyDates : []
        // 如果为空，生成默认的12个月
        if (this.xData.length === 0) {
          for (let i = 1; i <= 12; i++) {
            this.xData.push(i + '月')
          }
        }
      } else {
        // 使用保存的日期信息
        this.xData = this.dailyDates.length > 0 ? this.dailyDates : []
        // 如果为空，生成本月的所有日期
        if (this.xData.length === 0) {
          const now = new Date()
          const daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate()
          for (let i = 1; i <= daysInMonth; i++) {
            this.xData.push(i + '日')
          }
        }
      }
    },
    switchTimeType(type) {
      this.timeType = type
      // 切换时重新获取数据
      this.fetchData()
    },
    initChart() {
      this.myChart = echarts.init(this.$refs.chart)
      this.myChart.setOption(this.chartOption)
      
      // 添加事件监听
      this.addEventListeners()
    },
    handleResize() {
      if (this.myChart) {
        this.myChart.resize()
      }
    },
    addEventListeners() {
      // 添加点击事件
      this.myChart.on('click', (params) => {
        this.$emit('chart-click', params)
        console.log('点击了:', params.seriesName, params.name, params.value)
      })
    },
  }
}
</script>

<style lang="less" scoped>
.header {
  text-align: center;
  margin-bottom: 40px;
  padding: 20px;
  
  h1 {
    font-size: 32px;
    margin-bottom: 10px;
    color: #fff;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }
  
  p {
    color: #90979c;
    font-size: 16px;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
  }
}

.chart-container {
  display: flex;
  justify-content: center;
  height: 80%;
}

.chart-wrapper {
  width: 100%;
  max-width: 1200px;
  height: 95%;
  background: rgba(16, 33, 77, 0.3);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 20, 80, 0.4);
  border: 1px solid rgba(100, 150, 255, 0.2);
}

.controls {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
}

.control-btn {
  background: rgba(30, 60, 120, 0.7);
  border: 1px solid rgba(100, 150, 255, 0.3);
  color: #b3ccf8;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  
  &:hover {
    background: rgba(50, 100, 200, 0.7);
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 50, 150, 0.3);
  }
}

.data-info {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 30px;
  // margin-top: 30px;
}

.data-summary, .monthly-stats {
  background: rgba(20, 40, 80, 0.5);
  padding: 8px 15px;
  border-radius: 8px;
  flex: 1;
  min-width: 300px;
  border: 1px solid rgba(100, 150, 255, 0.2);
}

.data-summary h3, .monthly-stats h3 {
  margin: 0;
  color: #b3ccf8;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.data-summary p {
  margin: 8px 0 0 0;
  font-size: 12px;
  line-height: 1.4;
}

.highlight {
  color: #f9e264;
  font-weight: bold;
}
.time-switch {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin: 0;
}
.time-switch.inline {
  justify-content: flex-start;
  margin: 0;
}
.summary-header {
  margin: 8px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
  overflow: hidden;
}
.summary-header h3 {
  margin: 0;
  flex-shrink: 0;
}
.region-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  
  /deep/ .el-select {
    width: 100px;
    
    .el-input__inner {
      background-color: rgba(30, 60, 120, 0.5);
      border: 1px solid rgba(100, 150, 255, 0.3);
      color: #b3ccf8;
      font-size: 12px;
      height: 28px;
      line-height: 28px;
      padding: 0 8px;
      
      &::placeholder {
        color: #8ca0d7;
        font-size: 12px;
      }
    }
    
    .el-input__suffix {
      .el-input__suffix-inner {
        font-size: 12px;
      }
    }
    
    &:hover .el-input__inner {
      border-color: rgba(100, 150, 255, 0.5);
    }
  }
}
.date-filter {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  
  /deep/ .el-date-editor {
    width: 130px;
    
    .el-input__inner {
      background-color: rgba(30, 60, 120, 0.5);
      border: 1px solid rgba(100, 150, 255, 0.3);
      color: #b3ccf8;
      font-size: 12px;
      height: 28px;
      line-height: 28px;
      padding: 0 3px 0 24px; // 右侧留出30px给图标
      
      &::placeholder {
        color: #8ca0d7;
        font-size: 12px;
      }
    }
    
    .el-input__suffix {
      right: 8px;
      width: 20px;
      
      .el-input__suffix-inner {
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    
    .el-input__prefix {
      left: 1px;
    }
    
    &:hover .el-input__inner {
      border-color: rgba(100, 150, 255, 0.5);
    }
  }
}
.switch-btn {
  background: rgba(30, 60, 120, 0.5);
  border: 1px solid rgba(100, 150, 255, 0.3);
  color: #b3ccf8;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 12px;
  font-weight: normal;
  white-space: nowrap;
  height: 28px;
  line-height: 20px;

  &:hover {
    background: rgba(50, 100, 200, 0.7);
    border-color: rgba(100, 150, 255, 0.5);
  }

  &.active {
    background: rgba(25, 255, 224, 0.3);
    border-color: rgba(25, 255, 224, 0.6);
    color: #19ffe0;
    font-weight: bold;
    box-shadow: 0 0 8px rgba(25, 255, 224, 0.3);
  }
}

.month-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(100, 150, 255, 0.1);
  
  &:last-child {
    border-bottom: none;
  }
}

.month-name {
  font-size: 14px;
  color: #b3ccf8;
}

.month-value {
  color: #f9e264;
  font-weight: bold;
}

@media (max-width: 768px) {
  .chart-wrapper {
    height: 500px;
    padding: 15px;
  }
  
  .header h1 {
    font-size: 26px;
  }
  
  .data-info {
    flex-direction: column;
  }
  
  .controls {
    flex-direction: column;
    align-items: center;
  }
  
  .control-btn {
    width: 80%;
  }
}
</style>